<template>
    <section>
      <div class="dishes" id="dishes-slider">
        <div class="dishes__content">
          <div class="content__title content__title--small dishes__headline" style="text-transform:none">
            Rewolucyjna to 70 przepisów na pyszne roślinne dania
          </div>
          <div class="dishes__intro content__text">
            Znajdziesz w niej mnóstwo inspirujących przepisów na wegańskie dania z
            łatwodostępnych, na ogół lokalnych składników. Swoimi ulubionymi
            przepisami podzieliły się z nami osoby z całej Polski, ale także
            członkinie i członkowie Słusznej Strawy – spółdzielni współtworzonej
            przez osoby z doświadczeniem migracji i wspierającej osoby uchodźcze.
            Każdy przepis został przez nas wypróbowany, sfotografowany i opisany
            tak, aby każdy bez problemu poradził sobie nawet z lepieniem pierogów!
            <br /><br />
            „Rewolucyjna…” to kulinarna podróż po wegańskiej Polsce i nie tylko!
          </div>
        </div>
        <Slider />
      </div>
    <div class="dishes__end content__text">
      19 przepisów na lepszą Polskę sporządziliśmy wraz z osobami ze świata nauki i aktywizmu, które swoją postawą już teraz działają na rzecz zmiany. To rozmowy o lepszej przyszłości, marzeniach i inspiracjach, które mogą doprowadzić do ważnych przemian. 
      Znajdziesz w nich odważne idee, ambitne rozwiązania, a przede wszystkim nadzieję.
    </div>
  </section>

</template>

<script>
import Slider from "../elements/Slider";
export default {
  name: "SliderDishes",
  inject: ["content"],
  components: {
    Slider,
  },
};
</script>
